module.exports = __webpack_public_path__ + "img/chevron-button.svg";